import AxiosInstance from "./api";

export const InvoiceBooksService = {
  getAll: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/invoice-book?" + query.toString());
  },
  create: async (payload) => {
    return await AxiosInstance.post("/admin/invoice-book", payload);
  },
  getById: async (id) => {
    return await AxiosInstance.get("/private/invoice-book/" + id);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch("/admin/invoice-book/" + id, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete("/admin/invoice-book/" + id);
  },
  getCompanyByAuth: async () => {
    return await AxiosInstance.get("/private/invoice-book/company/auth");
  },
};
